import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/logo-header.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  class: "logo",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "micolist"
  }),
  /*#__PURE__*/_createTextVNode(" micolist ")
], -1)
const _hoisted_2 = { class: "search-box" }
const _hoisted_3 = ["onKeyup"]

import { ref } from "vue";
import MenuNav from "@/components/MenuNav.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheHeader',
  setup(__props) {

const searchWord = ref("");
const router = useRouter();

const sendSearch = () => {
  if (searchWord.value.length > 0) {
    router.push(`/search/${searchWord.value}`);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "search-input",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchWord).value = $event)),
        onKeyup: _withKeys(sendSearch, ["enter"])
      }, null, 40, _hoisted_3), [
        [_vModelText, searchWord.value]
      ])
    ]),
    _createVNode(MenuNav, { color: "pink" })
  ]))
}
}

})